// Use the existing slideshow pause button for banner videos too; no duplicate control.
document.querySelectorAll('slideshow-component').forEach(region=>{
 const button=region.querySelector('.slideshow__autoplay'),videos=[...region.querySelectorAll('video')];if(!button||!videos.length)return;
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 function sync(){const paused=button.classList.contains('slideshow__autoplay--paused');videos.forEach(video=>{if(paused)video.pause();else video.play().catch(()=>{})})}
 new MutationObserver(sync).observe(button,{attributes:true,attributeFilter:['class']});
 function reduce(){if(motion.matches&&!button.classList.contains('slideshow__autoplay--paused'))button.click();sync()}
 motion.addEventListener('change',reduce);requestAnimationFrame(reduce);
});
